<div class="mt-2 ml-3 mr-3 pt-2">
  <div class="flex justify-content-between col-12 bg-white btn-with-links p-3 font-semibold ">
    <label class="font-semibold uppercase category-name" translate>purchase_order.lbl_purchase_orders</label>
    @if(isAllowToAddProduct) {
    <p-button class="flex align-items-center justify-content-center" icon="pi pi-plus"
      [label]="'protocol.lbl_add_purchase_order' | translate" (click)="onAdd()"></p-button>
    }
  </div>
  @if(data){
  <app-mi-table
    [collectionOfColumns]="allColumns"
    [attributeLabels]="filterAttributeLabels"
    [data]="tableData"
    entityName="protocol_purchase_order"
    [isLoading]="isLoading"
    (onPageChange)="onPageChange($event)"
    (itemPerPageChange)="itemPerPageChange($event)"
    [totalRecords]="totalRecords"
    [itemsPerPage]="itemsPerPage"
    [message]="deleteSiteMsg"
    [header]="deleteSiteHeaderMsg"
    (onDelete)="onVehicleDelete($event)"
    (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
    (onRowSelection)="onRowSelect($event)"
    [filterList]="[]"
    (onValueChange)="onFilterValueChange($event)"
    [filterFields]="filterFieldsArray"
    [label]="btnLabel"
    (onBtnClick)="onAddVehicle()"
    [bulkUpdateLabel]="bulkUpdateLabel"
    [bulkDeleteLabel]="bulkDeleteLabel"
    [attributeData]="attributeData"
    (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
    (onSearchValueChange)="onSearchValueChanges($event)"
    (onUpdate)="onUpdatePurchaseOrder($event)"
    [rowItems]="rowItems"
    [bulkSelectionsItems]="bulkSelectionsItems"
    (setCurrentRowData)="setCurrentRowData($event)"
    [visiblePrintLabel]="visiblePrintLabel"
    [showBulkUpdateDialog]="showBulkUpdateDialog"
    (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
    [visible]="visible"
    [bulkUpdateHeader]="bulkUpdateHeader"
    [reviewHeader]="reviewHeader"
    [btnUpdate]="btnUpdate"

    (onSortData)="onSortData($event)">
  </app-mi-table>
  }
</div>

@if(showAddDialog) {
<!-- <p-dialog header="Add Purchase Order" [modal]="true" [(visible)]="showAddDialog" [style]="{ width: '60rem' }"
  (onHide)="onDialogClose()" (onShow)="onDialogShow()"> -->
  <app-add-purchase-order
    #addPurchaseOrder
    [protocolEntityId]="trialId"
    [purchaseOrderId]="purchaseOrderId"
    [showAddDialog] = "showAddDialog"
    (saveSuccess)="onSaveSuccess()"
    (onToggleOverLay)="onToggleOverlayForAdd()"
    (closePopup)="onClosePopup($event)"
    [isChangeReasonNotRequired]="isChangeReasonNotRequired"
    [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus">
  </app-add-purchase-order>
<!-- </p-dialog> -->
}